var map = {
	"./Chris-Goulding.jpg": "WCVc",
	"./Dante-Exum.jpg": "q8Sk",
	"./Duop-Reath.jpg": "gzXy",
	"./Dyson-Daniels.jpg": "ceHR",
	"./Jack-White.jpg": "Ll9a",
	"./Jock-Landale.jpg": "yJo+",
	"./Joe-Ingles.jpg": "2RY3",
	"./Josh-Giddey.jpg": "oHKc",
	"./Josh-Green.jpg": "dm7B",
	"./Keanu-Pinder.jpg": "38z+",
	"./Matisse-Thybulle.jpg": "p2lB",
	"./Matthew-Dellavedova.jpg": "sopk",
	"./Nick-Kay.jpg": "ur8D",
	"./Patty-Mills.jpg": "unTL",
	"./Sam-Froling.jpg": "ZQo1",
	"./Thon-Maker.jpg": "BbMk",
	"./Will-McDowell-White.jpg": "QAm4",
	"./Xavier-Cooks.jpg": "Izg7",
	"./blank.jpg": "908x",
	"./undefined.jpg": "7i7r"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "53WL";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images ^\.\/.*\.jpg$
// module id = 53WL
// module chunks = 1